const labels = {
    en: {
        RM: 'RM{price}{mth}',
        mth: '/mth',
        free: 'FREE'
    },
    ms: {}
};

export default labels;
